export function getImageFraction(options) {
    const {
        breakpoints: breakpointOptions = [],
        multiple = 60,
        ratio = null,
        maxPixelRatio = 2,
        path = null,
    } = options;
    let {
        fraction = 1,
    } = options;

    let maxWidth = 0;
    const sizes = [];
    const formats = {};
    const breakpoints = [
        { key: 'xs', breakpoint: 0, container: 367 },
        { key: 'xs', breakpoint: 415, container: 528 },
        { key: 'sm', breakpoint: 576, container: 508 },
        { key: 'md', breakpoint: 768, container: 672 },
        { key: 'lg', breakpoint: 992, container: 928 },
        { key: 'xl', breakpoint: 1200, container: 1140 },
        { key: 'xxl', breakpoint: 1400, container: 1320 },
        { key: 'xxxl', breakpoint: 1600, container: 1440 },
    ];

    breakpoints.forEach((breakpoint) => {
        fraction = breakpointOptions?.[breakpoint.key]?.fraction || fraction;

        const size = {
            breakpoint: breakpoint.breakpoint,
            width: breakpoint.container * fraction,
        };
        sizes.push(`${(size.breakpoint > 0 ? `(min-width: ${size.breakpoint}px) ` : '')}${size.width}px`);

        const width = Math.ceil((breakpoint.container * fraction) / multiple) * multiple;
        const height = ratio ? Math.round(width / ratio) : null;
        maxWidth = Math.max(maxWidth, width);

        for (let pixelRatio = 1; pixelRatio <= maxPixelRatio; ++pixelRatio) {
            const formatWidth = width * pixelRatio;
            const formatHeight = height ? height * pixelRatio : null;

            formats[`${formatWidth}x${formatHeight}`] = {
                'width': formatWidth,
                'height': formatHeight,
            };
        }
    });

    const maxHeight = ratio ? Math.round(maxWidth / ratio) : null;
    const src = getCloudImageUrl(path, {
        'width': maxWidth,
        'height': maxHeight,
    });
    const srcset = {};

    Object.values(formats).forEach((format) => {
        srcset[`${format.width}w`] = getCloudImageUrl(path, {
            'width': format.width,
            'height': format.height,
        });
    });

    return {
        'src': src,
        'srcSet': Object.entries(srcset).map(([key, value]) => `${value} ${key}`).join(', '),
        'width': maxWidth,
        'height': maxHeight,
        'sizes': sizes.reverse().join(', '),
    };
}

export function getCloudImageUrl(url, params = {}) {
    const cloudimageToken = process.env.NODE_ENV === 'production' ? 'apaxtxozen' : 'apaxtxozen';

    if (!cloudimageToken || !url) return url;

    const cloudimageUrl = new URL(`https://${cloudimageToken}.cloudimg.io/v7/${url}`);

    Object.entries(params).forEach(([key, value]) => {
        cloudimageUrl.searchParams.append(key, value === true ? 1 : value);
    });

    return cloudimageUrl.toString();
}
